import * as PIXI from "pixi.js";
import { FreeRoundsInfoBannerUpdateData } from "../../game/model/data/FreeRoundsResizeUpdateData";
import { Renderer } from "../../game/renderer/Renderer";
import { DisplayInfo } from "../../game/renderer/constant/RendererConstants";
import { FreeRoundsInfoBannerLocation } from "../../game/view/properties/AbstractFreeRoundsInfoBannerProperties";
/**
 * FreeRoundsUtils.ts
 */
export class FreeRoundsUtils {
    constructor() { }
    static getInstance() {
        if (!FreeRoundsUtils._instance) {
            FreeRoundsUtils._instance = new FreeRoundsUtils();
        }
        return FreeRoundsUtils._instance;
    }
    updateProperties(frProp) {
        const renderer = Renderer.getInstance();
        const orientation = renderer.getOrientation();
        let position;
        let scale;
        if (orientation == "landscape") {
            position = this.getLandscapeLocation(frProp);
            scale = this.getLandscapeScale();
        }
        else {
            position = this.getPortraitLocation(frProp);
            scale = this.getPortraitScale();
        }
        let colors = [];
        colors.push(frProp.headerTextColor);
        colors.push(frProp.headerBackgroundColor);
        colors.push(frProp.contentTextColor);
        colors.push(frProp.contentBackgroundColor);
        const frUpdate = new FreeRoundsInfoBannerUpdateData();
        frUpdate.setLocation(position);
        frUpdate.setScale(scale);
        frUpdate.setInfoBannerType(frProp.type);
        frUpdate.setInfoBannerColors(colors);
        return frUpdate;
    }
    getLandscapeLocation(frProp) {
        const renderer = Renderer.getInstance();
        const viewport = renderer.getViewport();
        const windowSize = renderer.getWindowSize();
        const result = new PIXI.Point(frProp.position.x, frProp.position.y);
        let ratioY = 0;
        if (windowSize.x > windowSize.y) {
            ratioY = windowSize.y / viewport.safeWidth;
        }
        else {
            let yScale = windowSize.y / viewport.safeHeight;
            let xScale = windowSize.x / viewport.safeWidth;
            ratioY = Math.min(xScale, yScale);
        }
        const gameSize = renderer.getGameSize();
        const _windowSize = renderer.getWindowSize();
        const ratio = _windowSize.y / gameSize.y;
        let _canvasHeight = viewport.height * ratio;
        let _canvasWidth = viewport.width * ratio;
        let _height = windowSize.y > _canvasWidth ? _canvasHeight : windowSize.y;
        let _width = windowSize.x > _canvasWidth ? _canvasWidth : windowSize.x;
        result.y *= ratio;
        if (frProp.type == FreeRoundsInfoBannerLocation.BOTTOM || frProp.type == FreeRoundsInfoBannerLocation.BOTTOM_RIGHT) {
            result.y = windowSize.y - DisplayInfo.NAVIGATION_BAR_HEIGHT;
            if (windowSize.y >= _height) {
                result.y += (windowSize.y - _height) / 2;
            }
        }
        result.x = result.x * ratioY;
        if (windowSize.x > _width) {
            result.x += (windowSize.x - _width) / 2;
        }
        if (frProp.type == FreeRoundsInfoBannerLocation.BOTTOM_RIGHT) {
            result.x = windowSize.x - (DisplayInfo.FREE_ROUNDS_WIDGET_SIZE.x * this.getLandscapeScale());
        }
        if (result.x < 0)
            result.x = 0;
        if (result.y < 0)
            result.y = 0;
        return result;
    }
    getPortraitLocation(frProp) {
        const renderer = Renderer.getInstance();
        const viewport = renderer.getViewport();
        const windowSize = renderer.getWindowSize();
        const result = new PIXI.Point(frProp.position.x, frProp.position.y);
        let ratioY = 0;
        let yScale = windowSize.y / viewport.safeHeight;
        let xScale = windowSize.x / viewport.safeWidth;
        if (windowSize.x > windowSize.y) {
            ratioY = windowSize.y / viewport.safeWidth;
        }
        else {
            ratioY = Math.min(xScale, yScale);
        }
        const gameSize = renderer.getGameSize();
        const _windowSize = renderer.getWindowSize();
        const ratio = _windowSize.y / gameSize.y;
        let _canvasHeight = viewport.height * ratio;
        let _canvasWidth = viewport.width * ratio;
        let _height = windowSize.y > _canvasWidth ? _canvasHeight : windowSize.y;
        let _width = windowSize.x > _canvasWidth ? _canvasWidth : windowSize.x;
        result.x = result.x * ratioY;
        if (windowSize.x > _width) {
            result.x += (windowSize.x - _width) / 2;
        }
        const holder = renderer.getHolder();
        result.y *= ratioY;
        if (holder.y > 0) {
            result.y += holder.y;
        }
        else {
            result.y += holder.y * (frProp.position.y / 1980 * 1.76);
        }
        let safeCanvasWidth = viewport.safeWidth * xScale;
        let safeCanvasHeight = viewport.safeHeight * yScale;
        let xOffset = Math.floor(((windowSize.x - safeCanvasWidth) / xScale) / 2);
        let yOffset = Math.floor(((windowSize.y - safeCanvasHeight) / yScale) / 2);
        let maxXOffset = Math.floor(((_canvasWidth - safeCanvasWidth) / xScale) / 2);
        let maxYOffset = Math.floor(((_canvasHeight - safeCanvasHeight) / yScale) / 2);
        xOffset = xOffset >= 0 ? Math.min(xOffset, maxXOffset) : 0;
        yOffset = yOffset < 0 ? 0 : yOffset > maxYOffset ? maxYOffset : yOffset;
        const st = renderer.getSafeTransform();
        console.log(`[FreeRoundsUtils] - _canvasHeight = ${_canvasHeight}`);
        console.log(`[FreeRoundsUtils] - windowSize.x = ${windowSize.x}`);
        console.log(`[FreeRoundsUtils] - windowSize.y = ${windowSize.y}`);
        console.log(`[FreeRoundsUtils] - ratioY = ${ratioY}`);
        console.log(`[FreeRoundsUtils] - this.getPortraitScale() = ${this.getPortraitScale()}`);
        console.log(`[FreeRoundsUtils] - viewport.height = ${viewport.height}`);
        console.log(`[FreeRoundsUtils] - holder.x = ${holder.x}`);
        console.log(`[FreeRoundsUtils] - holder.y = ${holder.y}`);
        console.log(`[FreeRoundsUtils] - yOffset = ${yOffset}`);
        console.log(`[FreeRoundsUtils] - xOffset = ${xOffset}`);
        if (frProp.type == FreeRoundsInfoBannerLocation.BOTTOM || frProp.type == FreeRoundsInfoBannerLocation.BOTTOM_RIGHT) {
            // result.y = _height - (DisplayInfo.NAVIGATION_BAR_HEIGHT * ratioY);
            // if (windowSize.y >= _height){
            //     result.y += (windowSize.y - _height)/2;
            // }
            result.y = windowSize.y - (DisplayInfo.NAVIGATION_BAR_HEIGHT * ratioY) - (DisplayInfo.FREE_ROUNDS_WIDGET_SIZE.y * this.getPortraitScale());
        }
        if (frProp.type == FreeRoundsInfoBannerLocation.BOTTOM_RIGHT) {
            result.x = windowSize.x - (DisplayInfo.FREE_ROUNDS_WIDGET_SIZE.x * this.getPortraitScale()) - holder.x;
        }
        if (result.x < 0)
            result.x = 0;
        if (result.y < 0)
            result.y = 0;
        return result;
    }
    getLandscapeScale() {
        const renderer = Renderer.getInstance();
        const gameSize = renderer.getGameSize();
        const windowSize = renderer.getWindowSize();
        return (windowSize.y / gameSize.y) * 1.5;
    }
    getPortraitScale() {
        const renderer = Renderer.getInstance();
        const viewport = renderer.getViewport();
        const windowSize = renderer.getWindowSize();
        let scale;
        if (windowSize.x > windowSize.y) {
            scale = windowSize.y / viewport.safeWidth;
        }
        else {
            const yScale = windowSize.y / viewport.safeHeight;
            const xScale = windowSize.x / viewport.safeWidth;
            scale = Math.min(xScale, yScale);
        }
        return scale * 1.4;
    }
}
FreeRoundsUtils.testRatio = 0;
//# sourceMappingURL=FreeRoundsUtils.js.map